<template>
  <div class="relative">
    <input
      v-model="query"
      class="peer text-slate-900 w-full"
      :placeholder="t('jc.component.userSearch.input.placeholder')"
      type="text"
      @keydown.enter.prevent="select"
    >
    <div
      class="absolute left-0 mt-2 z-20 w-56 origin-top-right rounded-sm bg-popover text-popover-foreground shadow-md ring-1 ring-black ring-opacity-5 focus:outline-none
        invisible peer-focus:visible hover:visible opacity-0 peer-focus:opacity-100 hover:opacity-100 transition-opacity"
    >
      <div
        class="flex flex-col gap-1 bg-white rounded"
      >
        <template
          v-for="user in users"
          :key="user.id"
        >
          <NuxtLink
            class="p-2 hover:bg-light text-slate-900"
            :to="localePath({
              name: 'user-user',
              params: {
                user: user.name,
              },
            })"
          >
            {{ user.name }}
          </NuxtLink>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { User } from '~/composables/charon'

const { charon } = useCharon()
const { t } = useI18n()
const localePath = useLocalePath()

const query = ref('')

function select() {
  if ((users.value?.length ?? 0) == 0) {
    return
  }
  navigateTo(localePath({
    name: 'user-user',
    params: {
      user: users.value![0].name,
    },
  }))
}

const { data: users } = useAsyncData(
  () => charon<User[]>(`/users`,
    {
      params: {
        'name[fuzzyi]': query.value,
        'sort': 'name[asc]',
        'size': 5,
      },
    }),
  {
    watch: [query],
  },
)
</script>
